<template>
  <div id="mm-prv-wdg">
    <img :src="baseURL + '/images/'+trackId+'/trpixel.gif'" style="width: 1px; height:1px;">
    <privacy />
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import Privacy from './components/Privacy'

export default {
  name: 'App',
  components: {
    Privacy
  },
  props: ['id'],
  computed: {
    ...mapGetters(['trackId']),
    ...mapState(['version', 'owner', 'site', 'ownerId', 'baseURL'])
  }
}
</script>

<style>
  #mm-prv-wdg {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue